import { Component, OnInit } from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

declare var $: any;
declare var toastr: any;
declare var document: any;

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit {

  constructor(private meta: Meta, private title: Title) {
    document.body.scrollTop = 0;
  }
  ngOnInit(): void {
    this.title.setTitle('IrvineTek | Agile Transformations Enabled By Technology');
    // Google / Search Engine Tags
    this.meta.updateTag({ property: 'name', content: 'IrvineTek | Agile Transformations Enabled By Technology' });
    this.meta.updateTag({ property: 'description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'image', content: 'https://irvinetek.com/assets/images/logo.png' });
    // Facebook Meta Tags
    this.meta.updateTag({ property: 'og:url', content: 'https://irvinetek.com/' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:title', name: 'title', content: 'IrvineTek | Agile Transformations Enabled By Technology' });
    this.meta.updateTag({ property: 'og:description', name: 'description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'og:image', name: 'image', content: 'https://irvinetek.com/assets/images/logo.png' });
    // Twitter Meta Tags
    this.meta.updateTag({ property: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ property: 'twitter:title', content: 'IrvineTek | Agile Transformations Enabled By Technology' });
    this.meta.updateTag({ property: 'twitter:description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'twitter:image', content: 'https://irvinetek.com/assets/images/logo.png' });

    $('.services-slider').owlCarousel({
      dots: true,
      dotData: true,
      autoplay: false,
      lazyLoad: true,
      loop: false,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: false,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 3,
        },
        800: {
          items: 4,
        },
        1000: {
          items: 5,
        }
      }
    });
  }
  changeTabs(event): void {
    $('.services-slider .nav-link').removeClass('active');
    $(event.target).addClass('active123');
  }
  changeTabsInd(event): void {
    $('.industries-slider .nav-link').removeClass('active');
    $(event.target).addClass('active123');
  }
}
